import { useContext, useEffect, useState } from 'react'

import { AuthContext, OrgContext, useApi, useEnvironmentConfig } from '@medable/medable-web-framework'
import { StudySidebarBlockType } from '@medable/medable-web-ui/dist/components/StudySidebarCard'
import { AuthContextType } from '@medable/medable-web-framework/dist/contexts/AuthContext'
import { OrgContextType } from '@medable/medable-web-framework/dist/contexts'

import { ApiUrl } from '@/constants/api.constants'
import { EnvironmentUtils } from '@/utils/environment/environment.utils'

export const useStudyCard = (): StudySidebarBlockType | undefined => {
  const { get } = useApi()
  const [envConfig] = useEnvironmentConfig()
  const { user } = useContext<AuthContextType>(AuthContext)
  const { roles: orgRoles } = useContext<OrgContextType>(OrgContext)

  const [studyCard, setStudyCard] = useState<StudySidebarBlockType>()

  const updateStatusCard = (newStatusCard: Partial<StudySidebarBlockType>) => {
    setStudyCard((oldStudyCard) => ({ ...oldStudyCard, ...newStatusCard }))
  }

  const initialize = () => {
    const {
      orgCode,
      environmentData: { region, envName },
    } = envConfig

    updateStatusCard({
      orgCode,
      environment: `${envName.toLowerCase()} (${region.toUpperCase()})`,
      modality: EnvironmentUtils.getVersion(),
    })

    getStudyInfo()
  }

  const getStudyInfo = async () => {
    const {
      data: [studyInfo],
    } = await get(ApiUrl.STUDY_INFO).res

    if (studyInfo) {
      updateStatusCard({
        studyName: studyInfo.c_name,
        studyId: studyInfo.c_protocol_number,
        studySponsor: studyInfo.c_sponsor_name,
      })
    }
  }

  const setRoles = () => {
    const role = orgRoles
      .filter((role) => user.roles.includes(role._id))
      .map((role) => role.name)
      .join(', ')

    updateStatusCard({ role })
  }

  useEffect(() => {
    initialize()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setRoles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgRoles])

  return studyCard
}
